import {type RestTypeWithTypename} from '../rest-type-with-typename';
import type {FetchPlanWarningsResponse} from './fetch-plan-warnings-for-child-query';

export function fetchPlanWarningsTypePatcher(
    data: FetchPlanWarningsResponse,
): RestTypeWithTypename<FetchPlanWarningsResponse> {
    return {
        __typename: 'FetchPlanWarningsResponse',
        result: {
            __typename: 'FetchPlanWarningsResult',
            plans: data.result.plans.map(plan => ({
                __typename: 'Plan',
                ...plan,
                behaviors: plan.behaviors.map(behavior => ({
                    __typename: 'Behavior',
                    ...behavior,
                    id: behavior.id,
                    payload: behavior.payload,
                    warnings: behavior.payload?.warnings.map(warning => ({
                        __typename: 'Warning',
                        ...warning,
                    })),
                })),
            })),
        },
    };
}
